export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-950">
      <div className="w-full max-w-[1160px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-base whitespace-nowrap">17</span>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">17吃瓜网</span>
            </div>
            <p className="text-xs md:text-sm text-background-50/60 leading-relaxed">
              17吃瓜网是国内领先的网红黑料与明星爆料聚合平台，覆盖17吃瓜黑料网、17黑料吃瓜等热门领域，每日追踪最新17吃瓜爆料与娱乐圈黑料资讯。吃瓜第一线，爆料不隔夜。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热搜榜', href: '#ranking' },
                { label: '视频爆料', href: '#media' },
                { label: '深度专题', href: '#carousel' },
                { label: '话题广场', href: '#topics' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(link.href);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-xs md:text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">热门话题</h4>
            <div className="flex flex-col gap-2">
              {['17吃瓜爆料', '网红黑料', '明星爆料', '内幕吃瓜', '娱乐圈黑料'].map((tag) => (
                <a
                  key={tag}
                  href="#topics"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector('#topics');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-xs md:text-sm text-background-50/50 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {tag}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs md:text-sm text-background-50/40 leading-relaxed">
              诚邀优质媒体与内容平台加入合作生态，共同打造健康积极的娱乐资讯环境。合作洽谈请通过联系页面与我们取得联系。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40 text-center sm:text-left">
            &copy; 2025 17吃瓜网 · 17吃瓜爆料 17吃瓜黑料 17黑料吃瓜 · 仅供娱乐资讯参考
          </p>
          <p className="text-xs text-background-50/30 text-center sm:text-right whitespace-nowrap">
            吃瓜第一线 · 爆料不隔夜
          </p>
        </div>
      </div>
    </footer>
  );
}